/** Common searchIcon */
const searchIcon = {
    display: "block",
    textAlign: "end",
};

export default (theme) => ({
    searchListContainer: {
        maxHeight: "65vh",
        overflow: "scroll",
        paddingBottom: "52px",
    },
    searchList: {
        border: `1px solid ${theme.palette.border.lightBorder}`,
        padding: theme.spacing(2),
        display: "flex",
    },
    addNewAsset: {
        border: `1px solid ${theme.palette.border.lightBorder}`,
        padding: theme.spacing(3),
        display: "flex",
        textTransform: "uppercase",
    },
    textBox: {
        width: "100%",
    },
    searchText: {
        fontWeight: "600",
        textDecoration: "underline",
    },
    editIcon: {
        ...searchIcon,
        margin: 10,
        color: theme.palette.success.main,
    },
    searchAssigned: {
        ...searchIcon,
        color: theme.palette.success.main,
    },
    searchLinked: {
        ...searchIcon,
        color: theme.palette.info.main,
    },
    searchNotExpected: {
        ...searchIcon,
        color: theme.palette.warning.main,
    },
    searchNotMandatory: {
        ...searchIcon,
        color: theme.palette.error.main,
    },
    searchNotRelated: {
        ...searchIcon,
        color: theme.palette.text.primary,
    },
});
